var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDieOne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M83.921,23.292c-0.092-3.956-3.264-7.145-7.213-7.264v-0.011H23.292v0.008c-3.974,0.092-7.174,3.293-7.267,7.267h-0.009v53.416h0.009c0.091,3.974,3.292,7.175,7.267,7.267v0.008h53.416v-0.009c3.975-0.092,7.176-3.292,7.267-7.267h0.009V23.292H83.921z M50,57.621c-4.21,0-7.621-3.411-7.621-7.62s3.412-7.621,7.621-7.621c4.208,0,7.621,3.412,7.621,7.621S54.209,57.621,50,57.621z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDieOne);
export default __webpack_public_path__ + "static/media/die-one.deabeeccaaeb31848a42b7fb0f6d09f1.svg";
export { ForwardRef as ReactComponent };